'use client';

import { teamSection } from '@stereoagency/sanity-schema';
import compact from 'just-compact';
import { useContext } from 'react';
import useSWR from 'swr';
import TeamSection from './TeamSection.client';
import { draftModeProfilesQuery } from './profilesQuery';
import { SanityDraftClientContext } from '@/components/context';

type Props = typeof teamSection.schema.teamSection;

export default function DraftModeTeamSection({
  title,
  subtitle,
  members
}: Props) {
  const ids = compact(members?.map((member) => member.profile?._ref) ?? []);
  const { client } = useContext(SanityDraftClientContext);
  const { data } = useSWR(`jobs-${ids.join('-')}`, () =>
    client?.fetch<(typeof draftModeProfilesQuery)[1]>(
      draftModeProfilesQuery[0],
      { ids }
    )
  );

  return (
    <TeamSection
      title={title}
      subtitle={subtitle}
      members={members}
      profiles={data ?? []}
    />
  );
}
